var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 8.33333L22.9166 12.5M22.9166 12.5L18.7499 16.6667M22.9166 12.5H9.37492M15.6249 4.37921C14.297 3.58153 12.7553 3.125 11.1111 3.125C6.12513 3.125 2.08325 7.32233 2.08325 12.5C2.08325 17.6777 6.12513 21.875 11.1111 21.875C12.7553 21.875 14.297 21.4184 15.6249 20.6208",
    stroke: "#DC444A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log-out-icon.17354a45b0fca82b4cc7ebc70bc035c2.svg";
export { ForwardRef as ReactComponent };